import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { auth } from '../config/firebase';
import LoadingScreen from './LoadingScreen';

/**
 * Autorise uniquement les administrateurs lorsque le site est en mode obsolète.
 */
const ObsoleteAdminGate: React.FC = () => {
  const { user, isAdmin, loading, initialized } = useAuthStore();

  if (!initialized || (loading && !initialized)) {
    return <LoadingScreen />;
  }

  const hasFirebaseSession = !!auth?.currentUser;

  if ((!user || !hasFirebaseSession) && initialized) {
    return <Navigate to="/" replace />;
  }

  if (user && !isAdmin && initialized) {
    return <Navigate to="/" replace />;
  }

  if (user && isAdmin && hasFirebaseSession && initialized) {
    return <Outlet />;
  }

  return <LoadingScreen />;
};

export default ObsoleteAdminGate;
